<div class="col-12">
  <div class="card">
    <div class="card-header" style="padding-bottom: 0">
      <h4 class="modal-title">
        {{ (mode == 'update' ? 'EditOrganization' : 'AddOrganization') | translate }}
        <app-help hrefKey="ExternalHelp.organizations" />
      </h4>
      <hr />
    </div>
    <div *ngIf="organization" class="card-body" style="padding-top: 0">
      <div class="row">
        <div class="col-xl-6">
          <div *ngIf="mode == 'update'" class="form-group">
            <label [innerHtml]="'Code' | translate"></label>
            <app-badge-organization [code]="organization.code" class="form-control" />
          </div>
          <div class="form-group">
            <label for="name" class="star" [innerHtml]="'Nom' | translate"></label>
            <input id="name" [(ngModel)]="organization.name" type="text" class="form-control" />
          </div>
          <div class="form-group">
            <label for="cluster-delegation">{{ 'UseDelegations' | translate }}</label>
            <ng-select
              id="cluster-delegation"
              (change)="filterAvailableCluster()"
              [items]="availableClusters"
              [multiple]="true"
              [closeOnSelect]="true"
              bindLabel="name"
              placeholder="Clusters"
              [(ngModel)]="clustersRead"
              autocomplete="off"
            ></ng-select>
          </div>
          <div class="bg-orange form-group">
            <p>
              <span class="warn-sign">⚠️</span><b>{{ 'WarningAdminDeleg' | translate }}</b>
            </p>
            <div class="mb-2 form-group" style="clear: both">
              <label for="admin-delegation">{{ 'AdminDelegations' | translate }}</label>
              <ng-select
                id="admin-delegation"
                (change)="filterAvailableCluster()"
                [items]="availableClusters"
                [multiple]="true"
                [closeOnSelect]="true"
                bindLabel="name"
                placeholder="Clusters"
                [(ngModel)]="clustersAdmin"
                autocomplete="off"
              ></ng-select>
            </div>
          </div>
          <div class="form-group">
            <label for="email" class="star" [innerHtml]="'AdresseMailOwner' | translate"></label>
            @if (mode === 'update') {
              <ng-select
                id="email"
                [items]="users$ | async"
                [loading]="loading"
                [typeahead]="userInput$"
                [clearable]="false"
                [searchable]="true"
                [minTermLength]="3"
                [(ngModel)]="organization.owner.email"
                bindValue="email"
                bindLabel="email"
              />
            }
            @if (mode === 'create') {
              <input id="email" class="form-control" type="email" [(ngModel)]="organization.owner.email" />
            }
          </div>
          <div class="form-group">
            <label for="featureFlags">{{ 'Feature flags' | translate }}</label>
            <ng-select
              [items]="FEATURE_FLAGS"
              [multiple]="true"
              [closeOnSelect]="false"
              [(ngModel)]="organization.featureFlags"
              autocomplete="off"
            ></ng-select>
          </div>
        </div>
        <div class="col-xl-6">
          <div class="form-group">
            <label for="country" [innerHtml]="'Pays' | translate"></label>
            <select id="country" name="countries" class="form-control" [(ngModel)]="organization.countryCode">
              <option *ngFor="let p of countries" [value]="p.code">{{ p.name }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="city" [innerHtml]="'Ville' | translate"></label>
            <input id="city" [(ngModel)]="organization.city" type="text" class="form-control" />
          </div>
          <div class="form-group">
            <label for="zip-code" [innerHtml]="'CodePostal' | translate"></label>
            <input id="zip-code" [(ngModel)]="organization.zipCode" type="text" class="form-control" />
          </div>
          <div class="form-group">
            <label for="street" [innerHtml]="'Rue' | translate"></label>
            <input id="street" [(ngModel)]="organization.street" type="text" class="form-control" />
          </div>
          <div *featureFlag="'mfaOrg'" class="form-group">
            <app-label label="RequireMFA" />
            <app-switch
              [(ngModel)]="organization.requireMfa"
              [highlightActiveLabel]="true"
              [showLabels]="true"
              id="mfa"
            ></app-switch>
          </div>
        </div>
        <fieldset *ngIf="mode == 'create'">
          <legend>
            {{ 'Contract.column' | translate }}
            <app-switch [(ngModel)]="createContract" [showLabels]="false" style="display: inline-block" />
          </legend>
          <div class="row" *ngIf="createContract">
            <div class="col-xl-6 col-md-8">
              <div class="form-group">
                <label class="required" [innerHtml]="'Contract.name' | translate"></label>
                <input class="form-control" [(ngModel)]="contract.name" name="name" [placeholder]="organization.name" />
              </div>
            </div>
            <div class="col-xl-3 col-md-4 col-sm-6">
              <div class="form-group">
                <label for="type">{{ 'Type' | translate }}</label>
                <ng-select [(ngModel)]="contract.type" [clearable]="false">
                  <ng-option *ngFor="let type of ContractTypes" [value]="type">
                    {{ 'Contract.typeEnum.' + type | translate }}
                  </ng-option>
                </ng-select>
              </div>
            </div>
            <div class="col-xl-3 col-md-4 col-sm-6">
              <div class="form-group">
                <label for="cdnEnabled">{{ 'Contract.cdnEnabled' | translate }}</label>
                <input type="checkbox" id="cdnEnabled" [(ngModel)]="contract.cdnEnabled" />
              </div>
            </div>
            <div class="col-xl-3 col-md-4 col-sm-6">
              <div class="form-group">
                <label [innerHtml]="'Contract.startDate' | translate"></label>
                <div class="input-group date">
                  <input
                    class="form-control"
                    placeholder="yyyy-mm-dd"
                    name="d"
                    #c="ngModel"
                    [(ngModel)]="contract.startDate"
                    [navigation]="'arrows'"
                    ngbDatepicker
                    #d="ngbDatepicker"
                  />
                  <button
                    class="btn btn-outline-secondary bi bi-calendar3 icofont icofont-ui-calendar mr-2"
                    (click)="d.toggle()"
                    type="button"
                  ></button>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-md-4 col-sm-6">
              <div class="form-group">
                <label>{{ 'Contract.millionRequestsPerMonth' | translate }}</label>
                <input class="form-control" [(ngModel)]="contract.millionRequestsPerMonth" type="number" min="0" />
              </div>
            </div>
            <div class="col-xl-3 col-md-4 col-sm-6">
              <div class="form-group">
                <label>{{ 'Contract.nbSitesAdvanced' | translate }}</label>
                <input class="form-control" [(ngModel)]="contract.nbSitesAdvanced" type="number" min="0" />
              </div>
            </div>
            <div class="col-xl-3 col-md-4 col-sm-6">
              <div class="form-group">
                <label>{{ 'Contract.nbSitesExpert' | translate }}</label>
                <input class="form-control" [(ngModel)]="contract.nbSitesExpert" type="number" min="0" />
              </div>
            </div>
          </div>
        </fieldset>
        <div *ngIf="mode == 'update'" class="col-md-12 mt-3">
          <app-admin-organization-users [organizationCode]="organization.code" />
        </div>
        <div *ngIf="mode == 'update' && organization.code" class="col-md-12 mt-3">
          <app-organization-contracts [organizationCode]="organization.code" />
        </div>
      </div>
    </div>
    <div *ngIf="organization" class="card-footer">
      <button
        *ngIf="mode == 'create'"
        id="submitAdd"
        [disabled]="!canValidate()"
        (click)="onCreate()"
        class="btn btn-sm btn-primary mr-2"
        [innerHtml]="'ajouter' | translate"
      ></button>
      <button
        *ngIf="mode == 'update'"
        id="submitSave"
        [disabled]="!canValidate()"
        (click)="updateOrganization(organization)"
        class="btn btn-sm btn-primary mr-2"
        [innerHtml]="'Enregistrer' | translate"
      ></button>
      <button
        (click)="organization = emptyOrganization(); back()"
        class="btn btn-sm btn-danger"
        [innerHtml]="'Annuler' | translate"
      ></button>
    </div>
  </div>
</div>
